import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled from "styled-components";
import { Button, Text } from "~/components-shared";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import signUpCompanySchema from "~/forms/SignUpCompanyForm/signUpCompanySchema";
import SignUpCompanyForm from "~/forms/SignUpCompanyForm";
const Form = styled.form`
  width: 100%;
`;
const SignUpCompany = _ref => {
  let {
    watch,
    onSubmit,
    ...rest
  } = _ref;
  const {
    t
  } = useTranslation();
  const defaultValues = {
    companyName: watch("companyName") || "",
    email: watch("email") || ""
  };
  const {
    handleSubmit,
    control
  } = useForm({
    resolver: yupResolver(signUpCompanySchema),
    defaultValues
  });
  const handleSubmitClick = handleSubmit(data => {
    onSubmit(data);
  });
  return /*#__PURE__*/React.createElement(Form, _extends({
    onSubmit: handleSubmitClick
  }, rest), /*#__PURE__*/React.createElement(Text, {
    fontSize: 4,
    lineHeight: 6,
    s: {
      mb: 4
    },
    align: "center",
    display: "block"
  }, t("SignUpCompany.info")), /*#__PURE__*/React.createElement(SignUpCompanyForm, {
    control: control
  }), /*#__PURE__*/React.createElement(Button, {
    fullWidth: true,
    s: {
      mb: 4,
      mt: 6
    },
    onClick: handleSubmitClick
  }, t("common.actions.continue")));
};
export default SignUpCompany;